<template>
  <div class="content">
    <div class="page-inner">
      <section class="scrollable">
        <div class="card mb-2">
          <div class="card-body">
            <h2 class="text-dark strong mb-0">{{ $t('spotify_playlists') }}</h2>
            <select class="form-control d-block mt-3" v-model="genreFilter" @change="getPlaylists()">
              <option value="">{{ $t('all_genres') }}</option>
              <option :value="genre" v-for="genre in genres" v-bind:key="genre">
                {{ genre }}
              </option>
            </select>
          </div>
        </div>
        <section class="mt-4 mb-lg-4">
          <div class="alert alert-warning" v-if="!accessToken">
            <div>{{ $t('please_give_us_authorization') }}</div>
            <div class="mt-4">
              <button type="button" class="btn btn-primary" @click="loginSpotify()"><i class="fab fa-spotify mr-2"></i> {{ $t('request_access' ) }}</button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4" v-for="(item) in populatedPlaylists" v-bind:key="item._id">
              <div class="card">
                <div class="card-body pt-3 pl-3 pr-3 pb-0">
                  <div class="clear">
                    <div class="pull-left strong">
                      <div class="text-muted block">
                        {{ $t('cost') }}: <span class="text-info">{{ parseInt(item.followers * followerCost) }} {{ $t('credits') }}</span>
                      </div>
                      <div class="text-muted block">
                        {{ $t('followers') }}: <span class="text-info">{{ item.followers }}</span>
                      </div>
                    </div>
                    <router-link :to="`/playlists/request/${item._id}`" class="btn btn-primary pull-right mb-4">
                      {{ $t('request_placement') }}
                    </router-link>
                  </div>
                </div>
                <iframe :src="item.embedUrl" width="100%" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
</div>
</template>
<script>
import genres from '../data/genres'
import _ from 'underscore'

export default {
  data: function () {
    return {
      followerCost: 1.5,
      accessToken: '',
      items: [],
      genreFilter: '',
      genres: _.map(genres, (genre, key) => {
        return key
      }),
      loading: false
    }
  },
  computed: {
    populatedPlaylists: function () {
      return _.filter(this.items, item => item.followers > 50)
    }
  },
  methods: {
    getPlaylists: function () {
      this.loading = true
      const filters = {
        main_genre: this.genreFilter
      }

      this.$http.get(`${window.apiURL}api/playlists`, { params: filters, withCredentials: true }).then(response => {
        const items = response.data

        _.each(items, item => {
          item.followers = 0
          item.image = ''
          item.name = ''
          item.embedUrl = item.url.replace('.com/user', '.com/embed/user')
        })

        this.items = items

        _.each(this.items, item => this.getPlaylistData(item))
        this.loading = false
      })
    },
    getPlaylistData: function (playlist) {
      let playlistId = playlist.url || ''

      try {
        if (playlistId.match(/\//)) {
          playlistId = playlistId.split('/playlist/')[1]
        }

        if (playlistId && playlistId.match(/\//)) {
          playlistId = playlistId.split('/')[0]
        }

        if (playlistId.match(/\?/)) {
          playlistId = playlistId.split('?')[0]
        }
      } catch (e) {
        console.error('Error when getting playlist id', playlist)
      }

      $.ajax({
        url: `https://api.spotify.com/v1/playlists/${playlistId}`,
        headers: {
          'Authorization': 'Bearer ' + this.accessToken
        },
        method: 'GET',
        success: (data) => {
          if (data && data.name) {
            playlist.name = data.name
          }

          if (data && data.images && data.images[0]) {
            playlist.image = data.images[0].url
          }

          if (data && data.followers) {
            playlist.followers = data.followers.total
          }
        },
        dataType: 'json',
        error: function (e) {
          console.error(e, playlist)
        }
      })
    },
    loginSpotify: function () {
      let baseUrl = ''

      if (location.href.match(/localhost/)) {
        baseUrl = 'http://localhost:8080/spotify-auth'
      } else {
        baseUrl = 'https://network.indiefy.net/spotify-auth'
      }

      let CLIENT_ID = '6e4a92b2f27b47de827b03198075ee37'
      let REDIRECT_URI = baseUrl

      function getLoginURL (scopes) {
        return 'https://accounts.spotify.com/authorize?client_id=' + CLIENT_ID +
          '&redirect_uri=' + encodeURIComponent(REDIRECT_URI) +
          '&scope=' + encodeURIComponent(scopes.join(' ')) +
          '&response_type=code'
      }

      let url = getLoginURL([
        'user-read-email',
        'user-follow-modify',
        'user-library-modify',
        'playlist-modify-public'
      ])

      window.addEventListener('message', function (event) {
        if (event.data && event.data.match && event.data.match(/\{/)) {
          let hash = JSON.parse(event.data)
          if (hash.type === 'access_token') {
            this.$spotify.token = hash.access_token
            this.accessToken = hash.access_token
            localStorage.setItem('spotifyToken', hash.access_token)
            localStorage.setItem('tokenDate', new Date().toString())
            this.getPlaylists()
          }
        }
      }, false)

      localStorage.setItem('redirectTo', '/playlists')
      location.href = url
    }
  },
  created () {
    if (this.$spotify.token) {
      this.accessToken = this.$spotify.token
      this.getPlaylists()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Playlists.vue